export default __webpack_public_path__ + "static/media/app-settings-icon-grey.5be2dec8.png";